import { IN_STOCK } from '@jouzen/ecom-components/v3/consts/stockStatus';
import type { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';
import type { FinishSelectionData } from '@jouzen/ecom-components/v3/FinishRadioSelectors';

import { getPriceAndDiscount } from '@/app/[locale]/product/_components/HardwarePDP/_utils/getPriceAndDiscount';
import type { ListProduct } from '@/queries/Products';

import getFinishSwatchImgixSrc from './getFinishSwatchImgixSrc';

export const getRingFinishesData = (
  baseData: FinishSelectionData[],
  handlePrefix: string,
  productData?: ListProduct[] | undefined,
): FinishSelectionData[] => {
  const finishesData = baseData.map((data) =>
    data.swatchSrc
      ? {
          ...data,
          swatchSrc: getFinishSwatchImgixSrc(data.swatchSrc),
        }
      : data,
  );

  const ringsData: ListProduct[] | undefined = productData?.filter(
    (product: ListProduct) => product.isRing,
  );
  const filteredRingsData = ringsData?.filter((product: ListProduct) =>
    product.handle.includes(handlePrefix),
  );

  filteredRingsData?.forEach((product) => {
    const finish = product.handle
      .split(`${handlePrefix}-`)
      .join('') as RingFinishEnum;
    const baseFinishes = finishesData.map((data) => data.id);

    if (baseFinishes.includes(finish)) {
      const index = finishesData.findIndex((data) => data.id === finish);
      const { discountPrice: discount, price } = getPriceAndDiscount(product);

      if (index !== -1 && finishesData[index]) {
        finishesData[index] = {
          ...finishesData[index],
          discount,
          price: price!,
          stockStatus: IN_STOCK, // @TODO: Implement stock status logic from size later variant
        };
      }
    }
  });

  return finishesData;
};
